/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.26.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UserFromJSON, UserToJSON, } from './';
export function WorkorderCompleteCommandFromJSON(json) {
    return WorkorderCompleteCommandFromJSONTyped(json, false);
}
export function WorkorderCompleteCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'workorderId': !exists(json, 'workorderId') ? undefined : json['workorderId'],
        'user': !exists(json, 'user') ? undefined : UserFromJSON(json['user']),
        'completionDateTime': !exists(json, 'completionDateTime') ? undefined : (json['completionDateTime'] === null ? null : new Date(json['completionDateTime'])),
    };
}
export function WorkorderCompleteCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'workorderId': value.workorderId,
        'user': UserToJSON(value.user),
        'completionDateTime': value.completionDateTime === undefined ? undefined : (value.completionDateTime === null ? null : value.completionDateTime.toISOString()),
    };
}
